import {
  ActivatedRouteSnapshot,
  Navigation,
  PRIMARY_OUTLET,
  UrlSegment,
  UrlSegmentGroup,
  UrlTree,
} from '@angular/router';
import { EventTime } from '@models/event/event';

interface PreviousNavigation {
  segments?: string[];
  queryParams?: Record<string, string>;
  fragment?: string;
}
export class UtilsHelper {
  static convertOneDigitToTwoDigitStr(digit: number): string {
    return digit < 10 ? `0${digit}` : digit?.toString();
  }

  static createDate(date: Date, time: EventTime): Date {
    const newDate = new Date(date);
    newDate.setHours(time.hour);
    newDate.setMinutes(time.minutes);
    return newDate;
  }

  static checkIsUrlHasExtensionType(url: string, extensionType: string): boolean {
    if (extensionType === 'jpg' || extensionType === 'jpeg') {
      return url.match(/\.(jpeg|jpg)$/) !== null;
    }

    if (extensionType === 'png') {
      return url.match(/\.(png)$/) !== null;
    }

    return false;
  }

  /**
   * title case only the first word of the string
   * @param { string } str phrase to title case
   * @returns { string } same phrase trimmed with an uppercase in first character
   */
  static titleCase(str: string): string {
    const strToTransform = str.trim();
    return `${strToTransform.charAt(0).toUpperCase()}${strToTransform.slice(1)}`;
  }

  /**
   *
   * @param { Navigation } nav currentNivigation provided by angular Router
   * @returns { PreviousNavigation } Object containing information to retrieve previous navigation url / params / fragments
   */
  static getPreviousNavigation(nav?: Navigation | null): PreviousNavigation {
    let segments: string[] | undefined;
    let fragment: string | undefined;
    let queryParams: Record<string, string> | undefined;

    if (nav) {
      const tree = nav.initialUrl as UrlTree;

      fragment = tree.fragment ?? undefined;
      queryParams = tree.queryParams;

      const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
      const s: UrlSegment[] = g?.segments;

      if (!!g && !!s) {
        segments = ['/', ...s.map((item) => item.path)];
      }
    }

    return {
      segments,
      queryParams,
      fragment,
    };
  }

  /**
   * Return resolved url from ActivatedRouteSnapshot
   * @param route
   * @returns string url
   */
  static getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route?.pathFromRoot
      .map((activeRoute: ActivatedRouteSnapshot) =>
        activeRoute.url.map((segment: UrlSegment) => segment.toString()).join('/')
      )
      .join('/');
  }
}
